/**
 * Reset content state
 * @param {Object} state - Content state object
 */
export const resetContent = (state) => {
  // Backup current content if it exists
  if (state.generatedContent.value) {
    state.previousContent.value = JSON.parse(JSON.stringify(state.generatedContent.value))
  }
  
  // Reset content state
  state.generatedContent.value = null
  state.lastGenerationParams.value = null
}
